export type UserSettings = {
  theme: {
    primary: string
    secondary: string
    isDark: boolean
  }
}

export default class SettingsService {
  static defaults = {
    primaryForLight: '#0B577C',
    primaryForDark: '#4e86a2',
    secondary: '#ff7f50',
    isDark: false,
  }

  static load(): UserSettings {
    //Initialize the settings from the default values
    let settings = {
      theme: {
        primary: SettingsService.defaults.primaryForLight,
        secondary: SettingsService.defaults.secondary,
        isDark: SettingsService.defaults.isDark,
      },
    }
    //Load the settings from the local storage and override the isDark property and
    //the primary color depending on the isDark value
    const settingsString = localStorage.getItem('settings')
    if (settingsString) {
      const settingsFromStorage = JSON.parse(settingsString)
      if (settingsFromStorage && settingsFromStorage.theme) {
        settings.theme.isDark = settingsFromStorage.theme.isDark
        SettingsService.setPrimaryColor(settings)
      }
    }
    return settings
  }

  static setPrimaryColor(settings) {
    if (settings.theme.isDark) {
      settings.theme.primary = SettingsService.defaults.primaryForDark
    } else {
      settings.theme.primary = SettingsService.defaults.primaryForLight
    }
  }
  // static saveTheme(theme) {
  //   const settings = SettingsService.load()
  //   settings.theme = theme
  //   localStorage.setItem('settings', JSON.stringify(settings))
  // }
  static setIsDark(isDark: boolean) {
    const settings = SettingsService.load()
    settings.theme.isDark = isDark
    SettingsService.setPrimaryColor(settings)
    localStorage.setItem('settings', JSON.stringify(settings))
    return settings
  }
}
